import { useEffect, useState } from 'react';

const useSearchParams = () => {
  const [searchParams, setSearchParams] = useState('');

  useEffect(() => {
    const { search } = window?.location;
    setSearchParams(search);
  }, []);

  return searchParams;
};

export default useSearchParams;
